/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 *
 *  Portal - Location View - TabPanel
 */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

// Design System
import Typography from '@material-ui/core/Typography';

function ContentHeader(props) {
  const { title, value, index } = props;
  const classes = styles();

  return (
    <div className={classes.root} styles={{ border: '1px solid red' }}>
      <Typography
        color='textPrimary'
        component='div'
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
      >
        {title}
      </Typography>
    </div>
  );
}

ContentHeader.propTypes = {
  title: PropTypes.string,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const styles = makeStyles(theme => ({
  root: {
    margin: '25px 15px 15px 25px',
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      margin: '25px 15px 15px 5px',
    },
  },
}));

export default ContentHeader;
